import { useTechnologiesData } from "./useTechnologiesData";
import { ApiTechnologies } from "@/api/technologies";
import { useLocalizedQuery } from "@/hooks/locale/useLocalizeQuery/useLocalizeQuery";

export const useTechnologiesPageData = () => {
  const { data: technologiesPage, isLoading: technologiesPageLoading } = useLocalizedQuery({
    queryKey: ["technologiesPage"],
    queryFn: async lang => ApiTechnologies.getTechnologiesPage(lang),
  });

  const { technologies, isLoading: technologiesLoading } = useTechnologiesData();

  return {
    technologiesPage: {
      technologiesPage,
      loading: technologiesPageLoading,
    },
    technologies: {
      technologies,
      loading: technologiesLoading,
    },
  };
};
